"use strict";

exports.__esModule = true;
var _H5 = _interopRequireDefault(require("./H1"));
exports.H1 = _H5.default;
var _H6 = _interopRequireDefault(require("./H2"));
exports.H2 = _H6.default;
var _H7 = _interopRequireDefault(require("./H3"));
exports.H3 = _H7.default;
var _H8 = _interopRequireDefault(require("./H4"));
exports.H4 = _H8.default;
var _Title2 = _interopRequireDefault(require("./Title"));
exports.Title = _Title2.default;
var _Text2 = _interopRequireDefault(require("./Text"));
exports.Text = _Text2.default;
var _A2 = _interopRequireDefault(require("./A"));
exports.A = _A2.default;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}